import { AssetOverviewGroup } from "~/components/asset-configuration-section";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { extractAssetKey, extractAssetValue } from "~/lib/assetUtils";
import { CopyText } from "~/components/CopyText";

const AssetInsightsTable = ({ group }: { group: AssetOverviewGroup }) => (
  <Table
    size="small"
    padding="normal"
    sx={{
      "& .MuiTableRow-root:hover": {
        background: "transparent",
      },
      "& .MuiTableCell-root": {
        px: 0,
        border: "none",
        fontSize: 14,
      },
    }}
  >
    <TableBody>
      {group?.items.map((item) => {
        const key = extractAssetKey(item);
        const value = extractAssetValue(item);

        return (
          <TableRow key={item.key}>
            <TableCell width="50%" sx={{ verticalAlign: "text-top" }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {key}
              </Typography>
            </TableCell>
            <TableCell width="50%" sx={{ verticalAlign: "text-top" }}>
              <Stack direction="row" alignItems="flex-start" gap={1}>
                <CopyText value={value}>{value}</CopyText>
              </Stack>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);

export default AssetInsightsTable;
